import React, { useRef, useState } from "react";

import SVG from "react-inlinesvg";


import { Button } from "react-bootstrap";
import cogoToast from "cogo-toast";
import { useSelector } from "react-redux";
import DynamicSimpleTable from "../../../../util/DynamicSimpleReactTable";
import { Card, CardBody, CardHeader } from "../../../../../_metronic/_partials/controls";
import { ViewIcon } from "../../../../util/Icons";
import { FilterGroup } from "../../../Common/components/FilterGroup";
import SimpleTable from "my-simple-react-table";
import { PARTNERS } from "../../../../util/constants/Partners";
import FeeModal from "../modals/FeeModal";

export const MaintenanceFeeSettings = () => {

    const tableRef = useRef();
    const [feeModal, setFeeModal] = useState({
        showViewFeeModal: false,
        details: null,
    });

    /* Modal show/hide Toggle */
    const toggleModal = (modal) => (_) => {
        setFeeModal({
            ...feeModal,
            [modal]: !feeModal[modal],
        });
    };

    const viewPartner = (details) => {
        setFeeModal({ ...feeModal, showViewFeeModal: true, details });
    };

    /* Action Buttons */
    const feeAction = (row) => {

        return (
            <span style={{ whiteSpace: "nowrap" }}>
                <Button
                    title="View Partner"
                    className="btn btn-icon btn-light btn-hover-primary btn-sm bg-white"
                    onClick={(_) => viewPartner(row)}
                >
                    <span className="svg-icon svg-icon-md svg-icon-primary">
                        <ViewIcon />
                    </span>
                </Button>

            </span>
        );
    };

    return (
        <>
            <Card>
                <CardHeader title={`Partners`} />
                <CardBody>
                    <SimpleTable
                        data={PARTNERS}
                        columns={[
                            { title: "Name", key: "name" },
                            { title: "Value", key: "value" },
                            { title: "", format: feeAction }
                        ]}
                    />
                </CardBody>
            </Card>
            {feeModal.showViewFeeModal && (
                <FeeModal
                    {...feeModal}
                    tableRef={tableRef}
                    onHide={toggleModal("showViewFeeModal")}
                />
            )}

        </>
    );
};
